import {
  RECORD_ORDERINFO,
  RECORD_USERINFO,
  RECORD_SPECINFO,
  RECORD_PROCESSED_PHOTO,
	RECORD_PROCESSED_PHOTO_NO_FAIR,
  RECORD_SELECTED_BG,
  RECORD_SEARCH_RESULTS,
  RECORD_LAST_SEARCH,
  RECORD_HOTSEARCH,
  RECORD_SERVICE_TEL,
  RECORD_CONSIGNEE_INFO,
  RECORD_PRICE,
  RECORD_PRINT_QTY,
  RECORD_PRINTPRICE
} from './mutation-types';

import { setStorage } from '../utils/utils'

export default {
  [RECORD_USERINFO](state, openId) {
    state.openId = openId;
    setStorage('openId', openId);
  },

  [RECORD_ORDERINFO](state, orderInfo) {
    state.orderInfo = orderInfo;
  },

  [RECORD_PROCESSED_PHOTO](state, processedPhoto) {
    state.processedPhoto = processedPhoto; 
  },
	[RECORD_PROCESSED_PHOTO_NO_FAIR](state, processedPhotoNoFair) {
	  state.processedPhotoNoFair = processedPhotoNoFair; 
	},
  [RECORD_SPECINFO](state, specInfo) {
    state.specInfo = specInfo;
  },

  [RECORD_SELECTED_BG](state, bgColor) {
    state.bgColor = bgColor;
  },
  [RECORD_SEARCH_RESULTS](state, searchResults) {
    state.searchResults = searchResults;
  },
  [RECORD_LAST_SEARCH](state, lastSearchWord) {
    state.lastSearchWord = lastSearchWord;
  },
  [RECORD_HOTSEARCH](state, hotSearch) {
    state.hotSearch = hotSearch;
  },
  [RECORD_SERVICE_TEL](state, serviceTelNumber) {
    state.serviceTelNumber = serviceTelNumber;
  },
  [RECORD_CONSIGNEE_INFO](state, consigneeInfo) {
    state.consigneeInfo = consigneeInfo;
  },
  [RECORD_PRICE](state, price) {
    state.price = price;
  },
  [RECORD_PRINTPRICE](state, printPrice) {
    state.printPrice = printPrice;
  },
  [RECORD_PRINT_QTY](state, printPhotoQty) {
    state.printPhotoQty = printPhotoQty;
  }
}
